import type { ListCollection } from '@chakra-ui/react';
import { createListCollection } from '@chakra-ui/react';

import type { Locale } from '@/libs/i18n';

type Option = { label: string
	value:                string };
type Leaf = { id: string

	localized: Record<string, string> };

export function toListCollectionFromLeafs(
	leafs: Leaf[] | undefined,
	locale: Locale,
): ListCollection<Option> {
	const items = (leafs ?? []).map(l => ({
		label: l.localized?.[locale] ?? l.localized?.en ?? l.localized?.th ?? '',
		value: l.id,
	})) ?? [];

	return createListCollection({ items });
}
